import { emailAddressSelector } from './selectors';
import useGetAuthenticatedUserProfile from './useGetAuthenticatedUserProfile';

export default function useEmailAddress() {
  return useGetAuthenticatedUserProfile({
    select: emailAddressSelector,
  });
}
